<template>
    <h1 class="headline">{{value}}</h1>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapState, mapGetters } = createNamespacedHelpers(parentModuleName);
export default {
    name: 'ProductTitle',
    computed: {
        value() {
            return this.getProductAttributeByLanguage(
                this.product,
                'product.name'
            );
        },
        ...mapState(['product']),
        ...mapGetters(['getProductAttributeByLanguage'])
    }
};
</script>